import React, { Component } from 'react';
import PropTypes from 'prop-types';

import EmptyView from 'components/EmptyView';

import {
  intentType,
  fieldsType,
  entityType,
  utteranceType,
  featureType,
} from 'types';
import ConstraintSetField from '../ConstraintSetField';

import './style.scss';

class ConstraintSetsFieldArray extends Component {
  renderEmptyView = () => {
    const {
      fields,
      hasMachineLearningFeatureEnabled,
      utterances,
      isXpack,
    } = this.props;
    if (
      fields.length ||
      (hasMachineLearningFeatureEnabled && utterances.length)
    ) {
      return null;
    }

    if (isXpack && !fields.length) {
      return (
        <EmptyView styleName="warning-view">
          <p>You can add extra Constraint Sets on this X-Pack Intent</p>
        </EmptyView>
      );
    }

    return (
      <EmptyView styleName="empty-view">
        <p>You need at least one Constraint Set to build your Intent</p>
      </EmptyView>
    );
  };

  render() {
    const {
      fields,
      featureTypes,
      allIntents,
      allEntities,
      isLoadingAllIntents,
      isLoadingAllEntities,
      addEntity,
      getAllIntents,
      getAllEntities,
      change,
      onScroll,
      refElement,
    } = this.props;
    return (
      <div data-test="constraint-sets" styleName="constraint-sets">
        {this.renderEmptyView()}
        {fields.map((field, index) => (
          <ConstraintSetField
            key={`${field}`}
            addEntity={addEntity}
            allEntities={allEntities}
            allIntents={allIntents}
            change={change}
            featureTypes={featureTypes}
            fields={fields}
            getAllEntities={getAllEntities}
            getAllIntents={getAllIntents}
            index={index}
            isLoadingAllEntities={isLoadingAllEntities}
            isLoadingAllIntents={isLoadingAllIntents}
            item={fields.get(index)}
            name={`${field}`}
            refElement={refElement}
            onScroll={onScroll}
          />
        ))}
      </div>
    );
  }
}

ConstraintSetsFieldArray.propTypes = {
  /* eslint-disable react/forbid-prop-types */
  fields: fieldsType.isRequired,
  /* eslint-disable react/no-typos */
  addEntity: PropTypes.func,
  allEntities: PropTypes.arrayOf(entityType),
  allIntents: PropTypes.arrayOf(intentType),
  change: PropTypes.func,
  featureTypes: PropTypes.arrayOf(featureType),
  getAllEntities: PropTypes.func,
  getAllIntents: PropTypes.func,
  hasMachineLearningFeatureEnabled: PropTypes.bool,
  isLoadingAllEntities: PropTypes.bool,
  isLoadingAllIntents: PropTypes.bool,
  isXpack: PropTypes.bool,
  refElement: PropTypes.object,
  utterances: PropTypes.arrayOf(utteranceType),
  onScroll: PropTypes.func,
};

export default ConstraintSetsFieldArray;
